import moment from 'moment';
require('daterangepicker');
let dt_index = null;
let microsite_id = null;

export function index(params){

    dt_index = $('#queries_table').DataTable({
        ajax: {
            url: $('#queries_table').attr('url'),
        },
        // select: {
        //     style: 'multi+shift',
        // },
        columns: [
            // { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            // { width: '65', data: null, orderable: false, searchable: false, class: 'actions', render: render_queries_actions },
            { data: 'query', orderable: true, searchable: true},
            { data: 'date_range', orderable: true, searchable: true, render: render_date_range},
            { data: 'hits', orderable: true, searchable: true },
            { data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'updated_at', orderable: true, searchable: true, render: datatables.render_datetime },
        ],
        order: [[4, 'desc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_queries"]').click(batch_delete_queries);
    });

    microsite_id = params.microsite_id;

    var start = moment().subtract(29, 'days');
    var end = moment();
 
    function datechange(start, end) {
        $('input[name="daterange"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
        index_reload();
    }

    function date_export(start, end) {
        $('input[name="export_dates"]').val(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
    }

    let date_range_config = {
        locale: {
            format: 'DD/MM/YYYY',
            separator: ' - ',
            applyLabel: window._('Aplicar'),
            cancelLabel: window._('Cancelar'),
            fromLabel: window._('De'),
            toLabel: window._('A'),
            daysOfWeek: [
                window._('Dom'),
                window._('Lun'),
                window._('Mar'),
                window._('Mie'),
                window._('Jue'),
                window._('Vie'),
                window._('Sab'),
            ],
            monthNames: [
                window._('Enero'),
                window._('Febrero'),
                window._('Marzo'),
                window._('Abril'),
                window._('Mayo'),
                window._('Junio'),
                window._('Julio'),
                window._('Agosto'),
                window._('Septiembre'),
                window._('Octubre'),
                window._('Noviembre'),
                window._('Diciembre'),
            ],
            firstDay: 1
        },
        linkedCalendars: false,
        showCustomRangeLabel: false,
        startDate: start,
        endDate: end,
        ranges: {
        'Hoy': [moment(), moment()],
        'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        alwaysShowCalendars : true,
        opens: 'left',
        autoApply: true,
    };

    

    $('input[name="daterange"]').daterangepicker(date_range_config, datechange);

    // datechange(start, end);

    $('#modal_export_queries').on('show.bs.modal', function(event){
        let modal = $(this);
        let select_group_by = modal.find('[name="group_by_export"]');
        let daterange = $('input[name="daterange"]').val();
        let array_dates = daterange.split('-');
        let startDate = array_dates[0].trim().replaceAll('/', '-');
        let endDate = array_dates[1].trim().replaceAll('/', '-');

        select_group_by.find('option[value="'+ $('select[name="group_by"]').val()).prop('selected', true);

        select_group_by.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        $('input[name="export_dates"]').daterangepicker({
            locale: {
                format: 'DD/MM/YYYY',
                separator: ' - ',
                applyLabel: window._('Aplicar'),
                cancelLabel: window._('Cancelar'),
                fromLabel: window._('De'),
                toLabel: window._('A'),
                daysOfWeek: [
                    window._('Dom'),
                    window._('Lun'),
                    window._('Mar'),
                    window._('Mie'),
                    window._('Jue'),
                    window._('Vie'),
                    window._('Sab'),
                ],
                monthNames: [
                    window._('Enero'),
                    window._('Febrero'),
                    window._('Marzo'),
                    window._('Abril'),
                    window._('Mayo'),
                    window._('Junio'),
                    window._('Julio'),
                    window._('Agosto'),
                    window._('Septiembre'),
                    window._('Octubre'),
                    window._('Noviembre'),
                    window._('Diciembre'),
                ],
                firstDay: 1
            },
            linkedCalendars: false,
            showCustomRangeLabel: false,
            startDate: moment(startDate, 'DD/MM/YYYY'),
            endDate: moment(endDate, 'DD/MM/YYYY'),
            ranges: {
            'Hoy': [moment(), moment()],
            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
            'Este mes': [moment().startOf('month'), moment().endOf('month')],
            'Último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            alwaysShowCalendars : true,
            opens: 'left',
            autoApply: true,
        }, date_export);
        // modal.find('input[name="export_dates"]').val(daterange);
    });
}

function render_date_range(data, type, row) {

    if(data == null){
        return '';
    }
    

    let group_by = $('select[name="group_by"]').val();
    if (group_by == 'months') {
        return moment(row['created_at']).format('MM/YYYY');
    } else if(group_by == 'years') {
        return moment(row['created_at']).format('YYYY');
    } else {
        return moment(row['created_at']).format('DD/MM/YYYY');
    }
    
}

// function render_queries_actions(data, type, row){

//     const url_info = ($("#queries_table").attr('url_info') ?? '').replace('#', row.id);

//     const actions = 
//         '<div class="btn-group" role="group">' +
//         '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
//         '</div>';

//     return actions;

// }

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();
}

function batch_delete_queries(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.queries.batch_delete'].replace('{microsite}', microsite_id);
    
    let queries_id = [];
    $.each(rows_selected, function(index, rowId){
        queries_id.push(rowId);
    });
    
    if(queries_id.length == 0){

        window.messages.error(__('No has seleccionado ninguna búsqueda'));

    } else {

        const title = __('Eliminar búsquedas');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una búsqueda.|[2,*] Estás a punto de eliminar :count búsquedas.', queries_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let queries_id of queries_id){
                        formData.append('queries_id[]', queries_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}